import { render, staticRenderFns } from "./BCitiesAutocomplete.vue?vue&type=template&id=657cf0b9"
import script from "./BCitiesAutocomplete.vue?vue&type=script&lang=js"
export * from "./BCitiesAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports